<template>
  <v-dialog v-model="dialog" fullscreen content-class="fullscreen-dialog">
    <Header :headTitle="title" isShowBackBtn @clickBack="cancel" />

    <div class="detail-page signup-agree">
      <!-- <DetailHeader btnType="close" :title="title" @headerCloseClick="cancel" /> -->
      <!-- <v-tabs v-model="tab" fixed-tabs @change="changeTab">
        <v-tab key="terms"> 이용약관 </v-tab>
        <v-tab key="policy"> 개인정보처리방침 </v-tab>
        <v-tab key="marketing"> 마케팅 동의 </v-tab>
      </v-tabs> -->

      <!-- 이용약관 -->
      <!-- <Terms v-if="tab === 'term'" /> -->
      <div v-if="tab === 'term'"  v-html="selectedPolicy.agreeTerms"></div>


      <!-- 개인정보처리방침  -->
      <!-- <Policy v-if="tab === 'policy'" /> -->
      <div v-if="tab === 'policy'"  v-html="selectedPolicy.agreePolicy"></div>


      <!-- 마케팅 동의 -->
      <!-- <Marketing v-if="tab === 'marketing'" /> -->
      <div v-if="tab === 'marketing'"  v-html="selectedPolicy.agreeMarketing"></div>

    </div>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import DetailHeader from "@/_zplabZPT/commonComp/DetailHeader.vue";
import Marketing from "@/_zplabZPT/commonComp/policy/Marketing.vue";
import Policy from "@/_zplabZPT/commonComp/policy/Policy.vue";
import Terms from "@/_zplabZPT/commonComp/policy/Terms.vue";
import Header from "@/_zplabZPT/commonComp/Header.vue";

export default {
  components: {
    DetailHeader,
    Terms,
    Policy,
    Marketing,
    Header
  },
  props: {},
  data() {
    return {
      dialog: false,
      tab: null,
      title: "",
      effectiveDateList: [],
    };
  },
computed: {
  selectedPolicy() {
    return this.effectiveDateList.find(
      (p) => p.policyId === this.selectedPolicyId
    );
  }
},

  mounted() {
    this.getPolicy().then((res) => {
      if (!res) return;
      this.policyData = res;

      // effectiveDateList 세팅
      this.effectiveDateList = res.data.map(policy => ({
        policyId: policy.policy_id,
        effectiveDate: this.$moment(policy.effectiveDate).format('YYYY년 MM월 DD일'),
        agreePolicy: policy.agreePolicy,
        agreeTerms: policy.agreeTerms,
        agreeMarketing: policy.agreeMarketing,
      }));

      // selectedPolicyId 초기값 세팅
      if (this.effectiveDateList.length > 0) {
        // nextTick으로 렌더링 후에 v-model 값 세팅
        this.$nextTick(() => {
          this.selectedPolicyId = this.effectiveDateList[0].policyId; // 초기값
        });
      }
    });
  },
  methods: {
    open(_tab) {
      this.tab=_tab;
      switch (_tab) {
        case "term":
          this.title = "개인정보의 수집 및 이용에 대한 동의";
          break;
        case "policy":
          this.title = "개인정보의 제3자 제공에 대한 동의";
          break;
        case "marketing":
          this.title = "의・약학적정보 전달 및 제품홍보 등 \n 마케팅 안내 관련 동의";
          break;
      }
      // this.changeTab(this.tab);

      this.dialog = true;
    },
    cancel() {
      this.dialog = false;
      this.$emit("clickCancel");
    },
    changeTab(e) {
      console.log(e);
      switch (e) {
        case 0:
          this.title = "개인정보의 수집 및 이용에 대한 동의";
          break;
        case 1:
          this.title = "개인정보의 제3자 제공에 대한 동의";
          break;
        case 2:
          this.title = "의・약학적정보 전달 및 제품홍보 등\n마케팅 안내 관련 동의";
          break;
      }
    },
    ...mapActions(["getPolicy"]),
  },
};
</script>

<style lang="scss">
.v-dialog.fullscreen-dialog {
  .signup-agree{
    background: #ffffff !important;

    .agree-content  {
      width: 90vw;
      margin: 0 auto;
      overflow: auto;
      height: calc(100vh - 100px);
      margin-top: 100px;
      font-size: 12px;
    }

    .v-tabs {
      position: relative;
      left: -1rem;
      width: 100vw;
      border-bottom: 1px solid var(--v-info-lighten4);

      .v-slide-group__prev {
        display: none !important;
      }

      .v-tab.v-tab--active {
        background: var(--v-info-lighten4);
      }
    }

    .v-tabs-items {
      margin-top: 1rem;
      font-size: 14px;
    }

    table {
      width: 100%;
      border-top: 1px solid var(--v-info-lighten4);
      border-collapse: collapse;
      margin: 20px 0 40px;
      font-size: 11px;
    }

    th {
      width: 100px;
      background:var(--v-info-lighten5);
      font-weight: 500;
      text-align: left;
      vertical-align: top;
    }

    th,
    td {
      border: 1px solid var(--v-info-lighten4);
      padding: 0.5rem;
    }

    // th:first-chils
  }
}
</style>
